export default __webpack_public_path__ + "static/media/background-home-sm.12104779.png";